// extracted by mini-css-extract-plugin
export default {"wrapper":"Dp-z","response":"Ep-z","error":"Fp-z","disabled":"Gp-z","buttons":"Hp-z","feedbackQuestionSection":"Ip-z","yesNoWrapper":"Jp-z"};